import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import { Tab as CoreTab } from '@vds-core/tabs';
import { TitleConfig, TypographyConfig, Title } from '@vds/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
var typescale = TypographyConfig.getTypescale();

var Tab = function Tab(props) {
  return /*#__PURE__*/React.createElement(CoreTab, _extends({}, props, {
    hitArea: true,
    focusState: true,
    minHeight: true,
    tabSpacing: calculateRem(0, 24, 0, 0),
    titleConfig: TitleConfig,
    typescale: typescale,
    Title: Title
  }));
};

export default Tab;